module.exports = __webpack_public_path__ + "static/media/SF-8-A.3fbe3d39.mp3";